import classNames from 'classnames';
import React from 'react';

import { TabProps } from './TabsTypes';
import { useTabsContext } from './hooks/useTabContext';

function Tab<TValue = string>({ className, value, children, ...rest }: TabProps<TValue>) {
    const { value: selectedValue, removeHiddenTabsFromDom } = useTabsContext<TValue>();
    const isSelected = selectedValue === value;

    const hideChildren = removeHiddenTabsFromDom && !isSelected;
    return (
        <div
            className={classNames('sgw-tab', className, { 'is-selected': isSelected })}
            id={String(`${value}-tabpanel`)}
            aria-labelledby={String(value)}
            role="tabpanel"
            {...rest}
        >
            {!hideChildren && children}
        </div>
    );
}

export default Tab;
